export var SEARCH_PARAMS_COOKIE_KEY = 'we_search_params';
export var REFERRING_DOMAIN_COOKIE_KEY = 'we_referring_domain';
export var QUERY_SEARCH_PARAMS_WHITELIST = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_sfid', 'owner_sfid', 'dclid', 'gclid', 'gclsrc'];